export default __webpack_public_path__ + "static/media/bg.b6057817.png";